export const NAV_LINKS = [
    { label: "HOME", to: "/" },
    { label: "SERVICES", to: "/services" },
    { label: "PROCESS", to: "/process" },
    { label: "CONTACT", to: "/contact" },
];
